/* @flow */
import AuthActions from 'auth/AuthActions';
import LinkConstants from 'constants/LinkConstants';
import * as React from 'react';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

class AdminSignupRedirect extends React.Component<{}> {
  static onEnter(
    nextState: RouterState,
    replaceWith: (location: LocationDescriptor) => void,
    callback: Function
  ) {
    const loggedIn = () => {
      replaceWith('/setup/admin_role');
      callback();
    };
    const notLoggedIn = () => {
      window.location = LinkConstants.SIGN_UP;
      callback();
    };

    AuthActions.checkLoggedInAndLoadAppData().then(loggedIn, notLoggedIn);
  }

  render() {
    return null;
  }
}

export default AdminSignupRedirect;
